import { Toolbar, Typography, Button, Box, IconButton, Stack } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import { AppBar } from "../Helper/DashboardNavHelper";
import { Circle } from "@mui/icons-material";
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import DarkModeToggle from "./Switch/DarkModeToggle";
const DashboardNavbar = ({ userEmail, onLogout, navState, openNav }) => {
  return (
    <AppBar elevation={0} position="fixed" open={navState} sx={{ boxShadow: 'none'}}>
      <Toolbar>
      <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={() => openNav(true)}
            edge="start"
            sx={{
                marginRight: 1,
                ...(navState && { display: 'none' }),
              }}
          >
            <MenuIcon />
        </IconButton>
        {/* Dashboard Title */}
        <Stack sx={{flexGrow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center'}} direction={'row'} spacing={1}>
        <SchoolOutlinedIcon  />
        <Typography fontWeight={"bold"} variant="h5" component="div" sx={{ flexGrow: 1 }}>
          Presentify
        </Typography>
        </Stack>

        {/* Display logged-in user's email */}
        {userEmail && (
          <Typography variant="caption" 
          sx={{ 
            fontWeight: 600, 
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            marginRight: 1
          }}>
            <Circle sx={{ fontSize: 10, color: 'primary.secondary' }} /> 
            {userEmail}
          </Typography>
        )}
        <DarkModeToggle />        
        {/* Logout Button */}
        <Button variant="outlined" color="secondary" onClick={onLogout}>
          Logout
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default DashboardNavbar;